<div class="prime-card">
    <div class="prime-card-wrapper">
        <header class="prime-card-header">
            <div class="header-back">
                <ng-container *ngTemplateOutlet="backButtonTemplate"></ng-container>
            </div>
            <div class="header-content">
                <h3 class="header-title-gradient">
                    {{
                        selectedRepaymentOption == repaymentOption.FORECLOSE
                            ? "Ready to foreclose your loan?"
                            : "Clear your EMI"
                    }}
                </h3>
                <h3 class="header-content-right">
                    <span class="fs-xl text-gradient-dark">Loan ID</span>
                    <span class="fs-xl text-purple"> {{ repaymentDetails?.loanId || "" }}</span>
                </h3>
            </div>
        </header>
        <section class="prime-card-body">
            <div class="body-content">
                <web-common-shimmer *ngIf="fullShimmer" height="20px" width="200px"></web-common-shimmer>
                <web-common-shimmer *ngIf="fullShimmer" height="20px" width="300px"></web-common-shimmer>
                <web-common-shimmer *ngIf="fullShimmer" height="20px" width="400px"></web-common-shimmer>
                <web-common-shimmer *ngIf="fullShimmer" height="20px" width="400px"></web-common-shimmer>

                <ng-container *ngIf="!fullShimmer">
                    <ng-container
                        *ngIf="defaultSelectedRepaymentOption == repaymentOption.FORECLOSE ? onlyForeclose : true"
                    >
                        <mat-radio-group
                            class="radio-group"
                            [formControl]="emiControl"
                            (change)="onRepaymentTypeChange($event)"
                        >
                            <ng-container
                                *ngFor="let option of loanDuration | keyvalue | orderBy: 'asc'; let i = index"
                            >
                                <mat-radio-button [value]="option.value">
                                    {{ option.value.displayLabel }}
                                </mat-radio-button>
                            </ng-container>
                        </mat-radio-group>
                    </ng-container>
                </ng-container>

                <web-table-shimmer *ngIf="fullShimmer || subShimmer" [rowCount]="10"></web-table-shimmer>

                <ng-container *ngIf="!fullShimmer && !subShimmer">
                    <div class="repayment-summary">
                        <div
                            class="repayment-summary-header"
                            *ngIf="selectedEmi?.periodStart && selectedEmi?.periodEnd"
                        >
                            <p class="fs-base fw-500 text-purple">PAYING FOR CYCLE</p>
                            <p class="fs-base fw-500 text-gradient-dark">
                                {{ formatEmiRange(selectedEmi?.periodStart, selectedEmi?.periodEnd) }}
                            </p>
                        </div>

                        <ng-container
                            *ngIf="
                                selectedRepaymentOption == repaymentOption.EMI ||
                                selectedRepaymentOption == repaymentOption.FORECLOSE
                            "
                        >
                            <div class="prime-subcard emi-detail-card">
                                <table class="info-table label-uppercase">
                                    <tbody>
                                        <div *ngIf="isRewardPointRedeemOn" class="form-field-item mb-5">
                                            <mat-label class="label uppercase"
                                                ><img
                                                    class="label-icon icon-filter-none opacity-1"
                                                    src="assets/svg/icons/brand-icon-fill.svg"
                                                    alt="brand-icon"
                                                />
                                                KLINQ Points</mat-label
                                            >
                                            <mat-form-field class="form-field-input-with-btn">
                                                <input
                                                    matInput
                                                    type="number"
                                                    [formControl]="rewardWallet"
                                                    class="uppercase-reset"
                                                    placeholder="Enter Points"
                                                    (keydown)="blockInvalidInput($event)"
                                                    (paste)="blockInvalidInput($event)"
                                                />
                                                <button
                                                    *ngIf="isRewardWalletApplied"
                                                    matSuffix
                                                    mat-icon-button
                                                    type="button"
                                                    class="right-mark"
                                                >
                                                    <img src="assets/svg/icons/check.svg" alt="right-mark" />
                                                </button>
                                                <button class="total-points" matSuffix mat-icon-button type="button">
                                                    of {{ maxUsableRedeemBalance }}
                                                </button>
                                                <button
                                                    *ngIf="!isRewardWalletApplied"
                                                    matSuffix
                                                    [disabled]="!rewardWallet.valid || isRewardWalletLoader"
                                                    type="button"
                                                    class="primary-gradient-btn use-btn"
                                                    (click)="rewardWalletClaim()"
                                                >
                                                    <span *ngIf="isRewardWalletLoader"
                                                        >Updating...<web-spinner></web-spinner>
                                                    </span>
                                                    <span *ngIf="!isRewardWalletLoader">Use</span>
                                                </button>

                                                <button
                                                    *ngIf="isRewardWalletApplied"
                                                    matSuffix
                                                    type="button"
                                                    [disabled]="isRewardWalletLoader"
                                                    class="primary-fill-btn remove-btn"
                                                    (click)="removeRewardWalletClaim()"
                                                >
                                                    <span *ngIf="isRewardWalletLoader"
                                                        >Updating...<web-spinner></web-spinner>
                                                    </span>
                                                    <span *ngIf="!isRewardWalletLoader">Remove</span>
                                                </button>
                                            </mat-form-field>
                                            <mat-error
                                                class="form-field-error text-center uppercase-reset"
                                                *ngIf="rewardWallet.hasError('max')"
                                            >
                                                You don’t have enough points yet
                                            </mat-error>
                                        </div>
                                        <tr>
                                            <td>PRINCIPAL AMOUNT</td>
                                            <td>
                                                {{
                                                    selectedEmi?.principal
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td>INTEREST AMOUNT</td>
                                            <td>
                                                {{
                                                    selectedEmi?.totalInterestAmount
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>
                                        <tr
                                            *ngIf="
                                                selectedEmi?.rePaymentStatus == repaymentStatus.PENDING &&
                                                selectedEmi?.paidAmount > 0
                                            "
                                        >
                                            <td>PAID AMOUNT</td>
                                            <td>
                                                -
                                                {{
                                                    selectedEmi?.paidAmount
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>

                                        <tr
                                            *ngIf="
                                                selectedRepaymentOption == repaymentOption.FORECLOSE &&
                                                (selectedEmi?.interestDiscount?.discountTValue ?? 0) +
                                                    (selectedEmi?.foreCloseDiscount ?? 0) >
                                                    0
                                            "
                                        >
                                            <td>
                                                DISCOUNT
                                                <img
                                                    class="info-icon"
                                                    src="assets/svg/icons/info-circle-outline.svg"
                                                    alt="more-info"
                                                    (click)="
                                                        openCalculationDialog(discountInfo, matDialogSizeService.wIII)
                                                    "
                                                />
                                            </td>
                                            <td class="text-success">
                                                -
                                                {{
                                                    (selectedEmi?.interestDiscount?.discountTValue ?? 0) +
                                                        (selectedEmi?.foreCloseDiscount ?? 0)
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>
                                        <tr
                                            *ngIf="
                                                selectedRepaymentOption != repaymentOption.FORECLOSE &&
                                                selectedEmi?.interestDiscount?.discountTValue > 0
                                            "
                                        >
                                            <td>
                                                DISCOUNT
                                                <img
                                                    class="info-icon"
                                                    src="assets/svg/icons/info-circle-outline.svg"
                                                    alt="more-info"
                                                    (click)="
                                                        openCalculationDialog(discountInfo, matDialogSizeService.wIII)
                                                    "
                                                />
                                            </td>
                                            <td class="text-success">
                                                -
                                                {{
                                                    selectedEmi?.interestDiscount?.discountTValue
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>
                                        <tr *ngIf="selectedEmi?.dueDate">
                                            <td>DUE DATE</td>
                                            <td>
                                                {{ selectedEmi?.dueDate | customDateFormat: "DD MMM YYYY" }}
                                            </td>
                                        </tr>
                                        <tr *ngIf="selectedEmi?.penalInterest">
                                            <td>
                                                PENAL CHARGE
                                                <img
                                                    class="info-icon"
                                                    src="assets/svg/icons/info-circle-outline.svg"
                                                    alt="more-info"
                                                    (click)="
                                                        openCalculationDialog(
                                                            penalChargesInfo,
                                                            matDialogSizeService.wIII
                                                        )
                                                    "
                                                />
                                            </td>
                                            <td class="text-danger">
                                                {{
                                                    selectedEmi?.penalInterest
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>
                                        <tr *ngIf="selectedEmi?.ecsCharge">
                                            <td>
                                                ECS CHARGE
                                                <img
                                                    class="info-icon"
                                                    src="assets/svg/icons/info-circle-outline.svg"
                                                    alt="more-info"
                                                    (click)="
                                                        openCalculationDialog(ecsChargesInfo, matDialogSizeService.wIII)
                                                    "
                                                />
                                            </td>
                                            <td class="text-danger">
                                                {{
                                                    selectedEmi?.ecsCharge
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>
                                        <tr *ngIf="selectedEmi?.writeOffAmount">
                                            <td>Write-Off Amount</td>
                                            <td class="text-danger">
                                                {{
                                                    selectedEmi?.writeOffAmount
                                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                                }}
                                            </td>
                                        </tr>
                                        <div *ngIf="isCouponRedeemOn" class="form-field-item mt-5">
                                            <mat-label class="label uppercase">Have a coupon?</mat-label>
                                            <mat-form-field class="form-field-input-with-btn">
                                                <input
                                                    class="uppercase-reset"
                                                    [ngClass]="{ 'text-success-dark': isCouponApplied }"
                                                    matInput
                                                    [formControl]="couponControl"
                                                    placeholder="Coupon Code"
                                                />
                                                <button
                                                    *ngIf="!isCouponApplied"
                                                    [disabled]="!couponControl.valid || isCouponLoader"
                                                    matSuffix
                                                    type="button"
                                                    class="primary-gradient-btn apply-btn"
                                                    (click)="couponRedeem()"
                                                >
                                                    <span *ngIf="isCouponLoader"
                                                        >Applying...<web-spinner></web-spinner>
                                                    </span>
                                                    <span *ngIf="!isCouponLoader">Apply</span>
                                                </button>
                                                <button
                                                    *ngIf="isCouponApplied"
                                                    matSuffix
                                                    mat-icon-button
                                                    type="button"
                                                    class="right-mark"
                                                >
                                                    <img src="assets/svg/icons/check.svg" alt="right-mark" />
                                                </button>
                                                <button
                                                    *ngIf="isCouponApplied"
                                                    matSuffix
                                                    type="button"
                                                    [disabled]="isCouponLoader"
                                                    class="primary-fill-btn remove-btn"
                                                    (click)="resetAppliedCouponCode()"
                                                >
                                                    <span *ngIf="isCouponLoader"
                                                        >Updating...<web-spinner></web-spinner>
                                                    </span>
                                                    <span *ngIf="!isCouponLoader">Remove</span>
                                                </button>
                                            </mat-form-field>

                                            <mat-error *ngIf="!isValidCouponValid" class="form-field-error">
                                                Sorry, this coupon code is invalid. Please try again.</mat-error
                                            >
                                        </div>
                                    </tbody>
                                </table>
                            </div>

                            <ng-container
                                *ngIf="
                                    selectedRepaymentOption === repaymentOption.FORECLOSE
                                        ? rewardPointMsg?.repaymentForeCloseRewardPoint?.title
                                        : rewardPointMsg?.repaymentEMIRewardPoint?.title
                                "
                            >
                                <div class="points-card">
                                    <h4 class="fs-md text-primary-40">
                                        {{
                                            selectedRepaymentOption === repaymentOption.FORECLOSE
                                                ? rewardPointMsg?.repaymentForeCloseRewardPoint?.subTitle
                                                : rewardPointMsg?.repaymentEMIRewardPoint?.subTitle
                                        }}
                                    </h4>

                                    <h3 class="fs-lg">
                                        {{
                                            selectedRepaymentOption === repaymentOption.FORECLOSE
                                                ? rewardPointMsg?.repaymentForeCloseRewardPoint?.title
                                                : rewardPointMsg?.repaymentEMIRewardPoint?.title
                                        }}
                                    </h3>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                    <ng-container
                        *ngIf="
                            selectedRepaymentOption == repaymentOption.CUSTOM &&
                            repaymentDetails?.isCustomAmountApplicable
                        "
                    >
                        <div class="form-field-item mb-10">
                            <mat-label class="label"
                                >Enter Custom Amount

                                <button
                                    type="button"
                                    class="more-info-tooltip-icon"
                                    matTooltip="Any amount entered will first be adjusted against all ECS charges, then all penal charges, and finally the principal."
                                    [matTooltipPosition]="'above'"
                                    matTooltipTouchGestures="on"
                                    aria-label="Amount adjustment order"
                                    #t="matTooltip"
                                    (click)="t.show()"
                                >
                                    <img src="assets/svg/icons/info-circle-outline.svg" alt="" />
                                </button>
                            </mat-label>

                            <mat-form-field class="form-field-input">
                                <input
                                    matInput
                                    type="number"
                                    [formControl]="customAmount"
                                    placeholder="Custom Amount"
                                    (keydown)="blockInvalidInput($event)"
                                    (paste)="blockInvalidInput($event)"
                                />
                            </mat-form-field>

                            <div class="form-field-below">
                                <p class="label">
                                    {{
                                        "Min " +
                                            (repaymentDetails?.minCustomAmount ?? 0
                                                | defaultBlank: "number" : { symbol: "₹", position: "before" }) +
                                            " | " +
                                            " Max" +
                                            (repaymentDetails?.maxCustomAmount ?? 0
                                                | defaultBlank: "number" : { symbol: "₹", position: "before" })
                                    }}
                                </p>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
        </section>

        <footer class="prime-card-footer">
            <div
                *ngIf="selectedRepaymentOption != repaymentOption.CUSTOM && !fullShimmer && !subShimmer"
                class="summary-bar"
            >
                <p class="fs-base">TOTAL</p>
                <h3 class="fs-xl text-purple">
                    {{ selectedEmi?.totalPayable | defaultBlank: "number" : { symbol: "₹", position: "before" } }}
                </h3>
            </div>
            <div class="prime-card-footer-left">
                <ng-container *ngTemplateOutlet="backButtonTemplate"></ng-container>
            </div>
            <div class="prime-card-footer-right">
                <button
                    type="button"
                    class="primary-outline-btn"
                    [disabled]="isDownloadSummary || fullShimmer || subShimmer"
                    (click)="downloadSummary()"
                    *ngIf="!repaymentDetails?.isCustomAmountApplicable"
                >
                    <span *ngIf="isDownloadSummary">Downloading...<web-spinner></web-spinner> </span>
                    <span *ngIf="!isDownloadSummary">Download Repayment Schedule</span>
                </button>
                <button
                    type="submit"
                    class="primary-gradient-btn"
                    [disabled]="
                        (selectedRepaymentOption == repaymentOption.CUSTOM && !customAmount.valid) ||
                        isPaymentLoader ||
                        fullShimmer ||
                        subShimmer
                    "
                    (click)="makePayment()"
                >
                    <span *ngIf="isPaymentLoader">Continue...<web-spinner></web-spinner> </span>
                    <span *ngIf="!isPaymentLoader">Make Payment</span>
                </button>
            </div>
        </footer>
    </div>
</div>

<ng-template #backButtonTemplate>
    <button type="button" class="back-btn back-outline-btn" [disabled]="fullShimmer || subShimmer" (click)="onBack()">
        <img class="back-btn-icon" src="assets/svg/icons/chevron-back.svg" alt="" />
        <span class="back-btn-text">Back</span>
    </button>
</ng-template>

<ng-template #penalChargesInfo>
    <div class="cmn-dialog-card-view">
        <div class="dialog-header">
            <h1 mat-dialog-title class="dialog-header-title-gradient">Here are your penalty details</h1>
        </div>
        <mat-dialog-content>
            <ng-container
                *ngIf="
                    selectedRepaymentOption == repaymentOption.EMI &&
                    selectedRepaymentLabel != repaymentDetails?.dueDelayEmiSum?.label
                "
            >
                <div class="dialog-body">
                    <table class="info-table label-uppercase" *ngIf="selectedEmi?.penalInterest > 0">
                        <tbody>
                            <h3 class="table-title">{{ selectedEmi?.label }}</h3>
                            <tr>
                                <td>Penalty fee per day</td>
                                <td>
                                    {{
                                        selectedEmi?.perDayPenalAmount || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before", format: true }
                                    }}
                                </td>
                            </tr>
                            <tr>
                                <td>Number of days delay</td>
                                <td>{{ selectedEmi?.penaltyDays || 0 }}</td>
                            </tr>
                            <tr>
                                <td>total</td>
                                <td>
                                    {{
                                        selectedEmi?.penalInterest || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before", format: true }
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
            <ng-container
                *ngIf="
                    (selectedRepaymentOption == repaymentOption.EMI &&
                        selectedRepaymentLabel == repaymentDetails?.dueDelayEmiSum?.label) ||
                    selectedRepaymentOption == repaymentOption.FORECLOSE
                "
            >
                <div class="dialog-body">
                    <ng-container *ngFor="let emi of repaymentDetails?.emis; let i = index">
                        <table
                            class="info-table label-uppercase"
                            *ngIf="emi?.penalInterest > 0 && emi?.rePaymentStatus != repaymentStatus?.DONE"
                        >
                            <tbody>
                                <h3 class="table-title">{{ "EMI " + (i + 1) }}</h3>
                                <tr>
                                    <td>Penalty fee per day</td>
                                    <td>
                                        {{
                                            emi?.perDayPenalAmount || 0
                                                | defaultBlank
                                                    : "number"
                                                    : { symbol: "₹", position: "before", format: true }
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Number of days delay</td>
                                    <td>{{ emi?.penaltyDays || 0 }}</td>
                                </tr>
                                <tr>
                                    <td>total</td>
                                    <td>
                                        {{
                                            emi?.penalInterest || 0
                                                | defaultBlank
                                                    : "number"
                                                    : { symbol: "₹", position: "before", format: true }
                                        }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                    <div class="table-total uppercase" *ngIf="hasMultiplePenaltyCharges()">
                        <p>Total penalty</p>
                        <p>
                            {{
                                repaymentDetails?.fullPayment?.penalInterest || 0
                                    | defaultBlank: "number" : { symbol: "₹", position: "before", format: true }
                            }}
                        </p>
                    </div>
                </div>
            </ng-container>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="dialog-actions">
                <div class="dialog-actions-btn">
                    <button type="button" class="primary-fill-btn btn-w100" mat-dialog-close>Got It</button>
                </div>
            </div>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #ecsChargesInfo>
    <div class="cmn-dialog-card-view">
        <div class="dialog-header">
            <h1 mat-dialog-title class="dialog-header-title-gradient">Here are your ECS details</h1>
        </div>
        <mat-dialog-content>
            <ng-container
                *ngIf="
                    selectedRepaymentOption == repaymentOption.EMI &&
                    selectedRepaymentLabel != repaymentDetails?.dueDelayEmiSum?.label
                "
            >
                <div class="dialog-body">
                    <table class="info-table label-uppercase">
                        <tbody>
                            <tr *ngIf="selectedEmi?.ecsCharge > 0">
                                <td>ECS Charge {{ selectedEmi?.label }}</td>
                                <td>
                                    {{
                                        selectedEmi?.ecsCharge || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before", format: true }
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
            <ng-container
                *ngIf="
                    (selectedRepaymentOption == repaymentOption.EMI &&
                        selectedRepaymentLabel == repaymentDetails?.dueDelayEmiSum?.label) ||
                    selectedRepaymentOption == repaymentOption.FORECLOSE
                "
            >
                <div class="dialog-body">
                    <table class="info-table label-uppercase">
                        <tbody>
                            <ng-container *ngFor="let emi of repaymentDetails?.emis; let i = index">
                                <tr *ngIf="emi?.ecsCharge > 0 && emi?.rePaymentStatus != repaymentStatus?.DONE">
                                    <td>ECS Charge EMI {{ i + 1 }}</td>
                                    <td>
                                        {{
                                            emi?.ecsCharge || 0
                                                | defaultBlank
                                                    : "number"
                                                    : { symbol: "₹", position: "before", format: true }
                                        }}
                                    </td>
                                </tr>
                            </ng-container>
                            <tr *ngIf="hasMultipleEcsCharges()">
                                <td>total</td>
                                <td>
                                    {{
                                        repaymentDetails?.fullPayment?.ecsCharge || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before", format: true }
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-container>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="dialog-actions">
                <div class="dialog-actions-btn">
                    <button type="button" class="primary-fill-btn btn-w100" mat-dialog-close>Got It</button>
                </div>
            </div>
        </mat-dialog-actions>
    </div>
</ng-template>

<ng-template #discountInfo>
    <div class="cmn-dialog-card-view">
        <div class="dialog-header">
            <h1 mat-dialog-title class="dialog-header-title-gradient">Discount</h1>
        </div>
        <mat-dialog-content>
            <div class="dialog-body">
                <table class="info-table label-uppercase">
                    <tbody>
                        <ng-container *ngFor="let discount of selectedEmi?.interestDiscount?.discountDetails">
                            <tr
                                *ngIf="
                                    discount?.discountType == discountTypeEnum.REWARD_WALLET && discount?.discount > 0
                                "
                            >
                                <td>KLINQ POINTS</td>
                                <td>
                                    -{{
                                        discount?.discount || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                    }}
                                </td>
                            </tr>
                            <tr
                                *ngIf="
                                    discount?.discountType == discountTypeEnum.COUPON_CODE_DISCOUNT &&
                                    discount?.discount > 0
                                "
                            >
                                <td>COUPON</td>
                                <td>
                                    -{{
                                        discount?.discount || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                    }}
                                </td>
                            </tr>
                            <tr *ngIf="discount?.discountType == discountTypeEnum.WAIVER && discount?.discount > 0">
                                <td>Waiver Discount ({{ discount?.code }})</td>
                                <td>
                                    {{
                                        discount?.discount || 0
                                            | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                    }}
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="selectedEmi?.foreCloseDiscount > 0">
                            <td>FORECLOSURE DISCOUNT</td>
                            <td>
                                -{{
                                    selectedEmi?.foreCloseDiscount || 0
                                        | defaultBlank: "number" : { symbol: "₹", position: "before" }
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="table-total uppercase">
                    <p>total</p>
                    <p>
                        {{ getDiscountTotal() | defaultBlank: "number" : { symbol: "₹", position: "before" } }}
                    </p>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="dialog-actions">
                <div class="dialog-actions-btn">
                    <button type="button" class="primary-fill-btn btn-w100" mat-dialog-close>Got It</button>
                </div>
            </div>
        </mat-dialog-actions>
    </div>
</ng-template>
